$(document).on('turbolinks:load', function () {
    let termination_form_field_type = $('#patient_record_termination_type');
    let outcome_indicator_select = $('#patient_record_status_outcome_indicator_id');
    let outcome_indicator_description = $('#closure-option-description')

    const set_select_options = function(select, url, data) {
        $.ajax({
            type: 'GET',
            url: url,
            data: data,
            success: function(json) {
                select.empty();
                select.append("<option value>"+json.empty_option+"</option>");
                let locale = json.locale
                json.options.forEach(item => {
                    let option_elem = document.createElement('option');
                    option_elem.value = item.id;
                    option_elem.innerHTML = get_item_name(locale, item)
                    select.append(option_elem);
                });
            }
        });
    };

    const get_item_name = function(locale, item) {
        let name = ''
        switch(locale) {
            case 'nl':
                name = item.name_nl
                break;
            case 'fr':
                name = item.name_fr
                break;
            case 'en':
                name = item.name_en
                break;
            default:
                name = item.name
        }
        return name
    }



    termination_form_field_type.change(function(){
        const termination_type = termination_form_field_type.val();
        const url = $(location).attr('pathname') + '/outcome_indicator_field';
        const data = {'termination_type': termination_type};
        set_select_options(outcome_indicator_select, url, data);
        outcome_indicator_description.html('')
    });
});

